import Tooltip from './Tooltip';
export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-tooltip/es/index.js
// module id = 370
// module chunks = 0